// 2.7.41 WSIssueMedia
export default class WSIssueMedia {
	constructor({
		type,
		operatorId,
		riderClassId,
	}) {
		/**
		 * @type string
		 * date
		 * (Required) It is used to identify the type of new media. Currently supported type is:
		 *  TransitAccountMedia – Deprecated, use SubsystemMedia
		 *  VirtualToken
		 *  IosEndorVTokenMedia
		 *  IosEndorWalletVTokenMedia
		 *  SubsystemMedia
		 *  TollingTransponder – FUTURE
		 *  CSCMedia (TransitCardBasedMedia) – FUTURE
		 *  OneAccountMedia – FUTURE (across multiple subsystems)
		 **/
		this.type = type;

		/**
		 * @type Number
		 * int
		 * (Optional) The Id of the operator performing the
		 * sale. If not provided, the configured NextWave
		 * operator Id is used to filter the catalog.
		 */
		this.operatorId = operatorId;

		/**
		 * @type Number
		 * int
		 * (Optional) The Id representing the fare category for
		 * 	the sale. If not provided, the configured NextWave
		 * operator Id is used to filter the catalog.
		 */
		this.riderClassId = riderClassId;
	}

	static fromBackoffice(data) {
		const result = new WSIssueMedia(data);
		return result;
	}

	toBackoffice() {
		const result = Object.freeze(this);

		return result;
	}

	toResolver() {
		const forGraphql = Object.freeze(this);

		return forGraphql;
	}
}

export const WSIssueMediaFragmentType = [];
export const InputWSIssueMediaFragmentType = WSIssueMediaFragmentType;

export const WSIssueMediaFragment = `
	type: String!
	operatorId: Int
	riderClassId: Int
`;

export const InputWSIssueMediaType = [
	...WSIssueMediaFragmentType,
	`
		input InputWSIssueMedia {
			${WSIssueMediaFragment}
		}
	`,
];

export const WSIssueMediaType = [
	...WSIssueMediaFragmentType,
	`
		type WSIssueMedia {
			${WSIssueMediaFragment}
		}
	`,
];
